import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

const countryMarketMapping = {
  AU: 'APAC', // Australia
  IN: 'APAC', // India
  ID: 'APAC', // Indonesia
  MY: 'APAC', // Malaysia
  NZ: 'APAC', // New Zealand
  PH: 'APAC', // Philippines
  SG: 'APAC', // Singapore
  TH: 'APAC', // Thailand
  VN: 'APAC', // Vietnam
  DK: 'EMEA', // Denmark
  FI: 'EMEA', // Finland
  IE: 'EMEA', // Ireland
  NO: 'EMEA', // Norway
  GB: 'UK', // United Kingdom // GB belongs to EMEA, use UK here for feature convenient
  SE: 'EMEA', // Seeden
  US: 'NA', // United States
  CA: 'NA', // Canada
  DE: 'LATAM', // Germany
  AT: 'LATAM', // Austria
  CH: 'LATAM', // Switerland
  ES: 'LATAM', // Spain
  MX: 'LATAM', // Mexico
  AR: 'LATAM', // Argentina
  CL: 'LATAM', // Chile
  CO: 'LATAM', // Colombia
  PE: 'LATAM', // Peru
  VE: 'LATAM', // Venezuela
  FR: 'LATAM', // France
  IT: 'LATAM', // Italy
  NL: 'LATAM', // Netherlands
  BR: 'LATAM', // Brazil
};

const issueValues = {
  RequestCallModal_AdvertiserSupport: 'I need help with Microsoft Advertising or have a general question',
  RequestCallModal_AgencySupport: 'I am an agency managing clients on Microsoft Advertising',
  RequestCallModal_ComplexSupportScenario: 'I have a question about Microsoft Shopping Campaign or conversion tracking',
  RequestCallModal_OptimizationConsult: 'I want coaching on how to optimize my campaign performance',
  RequestCallModal_SmartCampaign: 'I need help with Smart campaigns or have a general question',
  RequestCallModal_DMCSupport: 'I need help with Digital Marketing Center or have a general question',
  RequestCallModal_UPSupport: 'I need help with Multiplatform campaigns or have a general question',
  RequestCallModal_SmartPageSupport: 'I need help with Smart Pages or have a general question',
  RequestCallModal_ConversionTracking: 'I need help with conversion tracking',
};

export const UP_SUPPORT_CHAT_LINK = 'https://vsa.services.microsoft.com/en-us/v1.0/?product=bingads&issue=Ads-Experiment&disability=false&mode=live&partnerId=a1689b11-62c0-4f31-be04-05982f92b619&modality=occhat&flowId=Showcase-Exp&queue=/chat/122';

const featureIssuesMapping = {
  DMC: [
    { reasonKey: 'DMC-Support', reasonName: 'RequestCallModal_DMCSupport' },
  ],
  SmartCampaign: [
    { reasonKey: 'Smart-Campaign', reasonName: 'RequestCallModal_SmartCampaign' },
  ],
  // since the UP calls/chats will be routed to the DMC Support team,
  // for now we should go with the DMC Product Pair
  UP: [
    { reasonKey: 'DMC-Support', reasonName: 'RequestCallModal_UPSupport' },
  ],
  SmartPage: [
    { reasonKey: 'DMC-Support', reasonName: 'RequestCallModal_SmartPageSupport' },
  ],
  // special handle for en-US switch to expert user
  EnUsSwitchToExpert: [
    { reasonKey: 'DMC-Support', reasonName: 'RequestCallModal_AdvertiserSupport' },
  ],
  UPConversionTracking: [
    { reasonKey: 'Showcase-Support', reasonName: 'RequestCallModal_ConversionTracking', customSupportLink: UP_SUPPORT_CHAT_LINK },
    { reasonKey: 'Advertiser-Support', reasonName: 'RequestCallModal_AdvertiserSupport' },
  ],
  Default: [
    { reasonKey: 'Advertiser-Support', reasonName: 'RequestCallModal_AdvertiserSupport' },
  ],
};

const fullSupportList = [
  { reasonKey: 'Advertiser-Support', reasonName: 'RequestCallModal_AdvertiserSupport' },
  { reasonKey: 'Agency-Support', reasonName: 'RequestCallModal_AgencySupport' },
  { reasonKey: 'Complex-Support-Scenario', reasonName: 'RequestCallModal_ComplexSupportScenario' },
  { reasonKey: 'Optimization-Consult', reasonName: 'RequestCallModal_OptimizationConsult' },
];

const defaultSupportList = [
  { reasonKey: 'Advertiser-Support', reasonName: 'RequestCallModal_AdvertiserSupport' },
  { reasonKey: 'Agency-Support', reasonName: 'RequestCallModal_AgencySupport' },
  { reasonKey: 'Optimization-Consult', reasonName: 'RequestCallModal_OptimizationConsult' },
];

const frCAList = [
  { reasonKey: 'Advertiser-Support', reasonName: 'RequestCallModal_AdvertiserSupport' },
  { reasonKey: 'Agency-Support', reasonName: 'RequestCallModal_AgencySupport' },
];

const jaJPList = [
  { reasonKey: 'Advertiser-Support', reasonName: 'RequestCallModal_AdvertiserSupport' },
];

const defaultSupportListForChat = [
  { reasonKey: 'Advertiser-Support', reasonName: 'RequestCallModal_AdvertiserSupport' },
  { reasonKey: 'Agency-Support', reasonName: 'RequestCallModal_AgencySupport' },
  { reasonKey: 'Complex-Support-Scenario', reasonName: 'RequestCallModal_ComplexSupportScenario' },
];

const marketIssuesMappingV2 = {
  NA: fullSupportList,
  // UK: fullSupportList,
  Default: defaultSupportList,
};

const marketIssuesMappingV2ForChat = {
  Default: defaultSupportListForChat,
};

export class SupportCategorySelector extends React.PureComponent {
  static propTypes = {
    onMount: PropTypes.func,
    onSelectChange: PropTypes.func,
    i18n: PropTypes.shape({
      getString: PropTypes.func,
      getCldr: PropTypes.func,
    }).isRequired,
    featureName: PropTypes.string,
    for: PropTypes.string,
    classes: PropTypes.string,
    permissions: PropTypes.shape({
    }),
    market: PropTypes.shape({
      region: PropTypes.string,
      language: PropTypes.string,
    }),
  };

  static defaultProps = {
    featureName: '',
    onMount: _.noop,
    onSelectChange: _.noop,
    classes: '',
    permissions: {},
    for: 'call',
    market: undefined,
  };

  constructor(props) {
    super(props);
    let { region } = this.props.i18n.getCldr().attributes;
    const { bundle } = this.props.i18n.getCldr().attributes;
    if (props.market) {
      ({ region } = props.market);
    }

    let mapping = marketIssuesMappingV2;
    if (props.for === 'chat') {
      mapping = marketIssuesMappingV2ForChat;
    }
    this.issueList = props.featureName ?
      (featureIssuesMapping[props.featureName] || featureIssuesMapping.Default) :
      (mapping[countryMarketMapping[region]] || mapping.Default);

    if (bundle === 'fr-CA' && props.for !== 'chat' && !props.featureName) {
      this.issueList = frCAList;
    }

    if (bundle === 'ja' && !props.featureName) {
      this.issueList = jaJPList;
    }

    this.state = {
      issueIndex: this.issueList.length > 1 ? '-1' : '0',
    };
  }

  componentDidMount() {
    const issue = this.state.issueIndex === '-1' ?
      this.state.issueIndex : this.issueList[this.state.issueIndex].reasonKey;
    this.props.onMount(issue);
  }

  handleSelectChange = (e) => {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value, // set issueIndex
    });

    if (value === '-1') {
      this.props.onSelectChange(value);
    } else {
      const { reasonKey: issue, customSupportLink } = this.issueList[value];
      this.props.onSelectChange(issue, customSupportLink);
    }
  };

  render() {
    const reasonInputId = `reason-input-${_.uniqueId()}`;

    return (
      <div className={`support-category-selector ${this.props.classes}`}>
        <div className="form-group">
          <label htmlFor={reasonInputId}>
            {this.props.market ? 'How can we help you?' : this.props.i18n.getString('RequestCallModal_ReasonForCall')}
            <select
              className="form-control"
              name="issueIndex"
              id={reasonInputId}
              onChange={this.handleSelectChange}
              value={this.state.issueIndex}
              data-analyticsid="request-call-form_issueIndex"
            >
              {
                this.issueList.length > 1 &&
                <option
                  key={-1}
                  value={-1}
                />
              }
              {this.issueList.map(({ reasonKey, reasonName }, index) => (
                <option
                  key={reasonKey + reasonName}
                  value={index}
                  data-analyticsvalue={issueValues[reasonName]}
                >
                  {
                    this.props.market ? issueValues[reasonName]
                    : this.props.i18n.getString(reasonName)
                  }
                </option>
              ))
              }
            </select>
          </label>
        </div>
      </div>
    );
  }
}

